document.addEventListener("DOMContentLoaded", function () {
    gsap.set('.co-os-s5-img.z-ani-o', { opacity: 0, y: 20, x: 5 });
    gsap.set('.co-os-s5-text .z-ani-o', { opacity: 0, y: 40 });
    let cOsS5Tl1 = gsap.timeline({ paused: true });
    cOsS5Tl1.to('.co-os-s5-img.z-ani-o', {
        y: 0,
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut"
    });
    cOsS5Tl1.to('.co-os-s5-text .z-ani-o', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-os-s5-text .z-ani-o',
        start: "40% bottom",
        end: "bottom top",
        animation: cOsS5Tl1
    });
});